import React, { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { FileText, Download, Loader2 } from "lucide-react";

const PDFPreview = ({ isOpen, onClose, pdfUrl, onConfirm, isLoading }) => {
  const [pdfData, setPdfData] = useState(null);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    if (isOpen && pdfUrl) {
      setPdfData(pdfUrl);
      setLoadError(false);
    }
  }, [isOpen, pdfUrl]);

  const handleDownload = () => {
    if (pdfData) {
      const link = document.createElement("a");
      link.href = pdfData;
      link.download = "Anwahlfolgen_Vorschau.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50" 
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-2xl w-[90vw] max-w-5xl h-[90vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b bg-slate-50">
          <h2 className="font-manrope font-semibold text-lg flex items-center gap-2">
            <FileText className="w-5 h-5 text-[#1e3a5f]" />
            PDF-Vorschau
          </h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* PDF Viewer */}
        <div className="flex-1 bg-slate-200 overflow-hidden">
          {isLoading ? (
            <div className="h-full flex items-center justify-center bg-white">
              <div className="text-center">
                <Loader2 className="w-10 h-10 animate-spin text-[#1e3a5f] mx-auto mb-3" />
                <p className="text-slate-600">PDF wird generiert...</p>
              </div>
            </div>
          ) : loadError ? (
            <div className="h-full flex items-center justify-center bg-white">
              <div className="text-center">
                <FileText className="w-16 h-16 text-slate-300 mx-auto mb-3" />
                <p className="text-slate-600 mb-4">PDF konnte nicht im Browser angezeigt werden</p>
                <Button variant="outline" onClick={handleDownload}>
                  <Download className="w-4 h-4 mr-2" />
                  PDF herunterladen
                </Button>
              </div>
            </div>
          ) : pdfData ? (
            <iframe
              src={pdfData}
              className="w-full h-full border-0"
              title="PDF-Vorschau"
              onError={() => setLoadError(true)}
            />
          ) : (
            <div className="h-full flex items-center justify-center bg-white">
              <p className="text-slate-500">Keine Vorschau verfügbar</p>
            </div>
          )}
        </div>
        
        {/* Footer */}
        <div className="flex items-center justify-between px-6 py-4 border-t bg-white">
          <Button
            variant="outline"
            onClick={handleDownload}
            disabled={!pdfData || isLoading}
            data-testid="download-preview-btn"
          >
            <Download className="w-4 h-4 mr-2" />
            PDF herunterladen
          </Button>
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              data-testid="cancel-preview-btn"
            >
              Abbrechen
            </Button>
            <Button
              onClick={onConfirm}
              disabled={isLoading}
              className="bg-[#1e3a5f] hover:bg-[#0d2137] text-white"
              data-testid="confirm-submit-btn"
            >
              Formular absenden
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PDFPreview;
